//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "SizingHelp",
  props: {
    info: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      openIndex: null,
      ringSizes: [
        {mm: 46.8, rs: 4},
        {mm: 48, rs: 4.5},
        {mm: 49.3, rs: 5},
        {mm: 50.6, rs: 5.5},
        {mm: 51.9, rs: 6},
        {mm: 53.1, rs: 6.5},
        {mm: 54.4, rs: 7},
        {mm: 55.7, rs: 7.5},
        {mm: 57, rs: 8},
        {mm: 58.3, rs: 8.5},
        {mm: 59.5, rs: 9},
        {mm: 60.8, rs: 9.5},
        {mm: 62.1, rs: 10},
        {mm: 63.4, rs: 10.5},
        {mm: 64.6, rs: 11},
        {mm: 65.9, rs: 11.5},
        {mm: 67.2, rs: 12},
        {mm: 68.5, rs: 12.5},
        {mm: 69.7, rs: 13},
      ]
    }
  },
  computed: {
    sizingHelp() {
      return {
        sizeHeadInfo: this.info.content?.sizing_help?.sizing ? this.info.content.sizing_help.sizing : {},
        accordion: this.info.content?.sizing_help?.accordion ? this.info.content.sizing_help.accordion : [],
      }
    }
  },
  methods: {
    close() {
      this.$parent.$emit('changeStage', 'configurator')
    }
  },
}
